<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64">
    <g fill="none" fill-rule="evenodd">
        <g fill="#000">
            <g>
                <path class="fill" d="M32 2.667C48.2 2.667 61.333 15.8 61.333 32S48.2 61.333 32 61.333c-4.455 0-8.679-.993-12.461-2.77l-1.753.58c-5.965 1.912-10.133 2.572-12.504 1.981-2.799-.698-3.351-1.919-1.657-3.663 1.171-1.396 2.147-3.14 2.928-5.234.622-1.668.377-4.001-.737-7C3.8 41.253 2.666 36.759 2.666 32 2.667 15.8 15.8 2.667 32 2.667zM32 8C18.745 8 8 18.745 8 32c0 3.5.747 6.88 2.168 9.978l.405.837.137.271.106.285c1.517 4.085 1.89 7.622.734 10.72l-.382.972-.192.433.235-.05c1.38-.317 3.017-.767 4.886-1.363l1.721-.568 2.04-.696 1.95.917C24.965 55.22 28.422 56 32 56c13.255 0 24-10.745 24-24S45.255 8 32 8z" transform="translate(-210 -431) translate(210 431)"/>
            </g>
        </g>
    </g>
</svg>
